<template>
  <div>
    <div class="container-fluid">
      <b-row v-if="loaded">
        <p>
          Yazılımı kullanmaya devam etmek için {{user.company.frozen_price}} TL ödeme yapmanız gerekiyor. Lütfen Ödemeyi Tamamlayınız.
        </p>
        <b-button variant="success" @click="showPaymentModal(1, user.company.frozen_price)">
          Hemen Satın Al
        </b-button>
      </b-row>
      <b-row v-else>
        <b-col class="text-center">
          <b-spinner />
        </b-col>
      </b-row>
    </div>

    <b-modal title="3D ile Öde" ref="paymentModal" @hide="resetPaymentModal" hide-footer>
      <form action="https://api.ecarihesap.com/3ds-check" method="POST">
        <input type="hidden" name="user_id" :value="userId">
        <input type="hidden" name="package_id" :value="modal.package_id">
        <b-form-group>
          <label>Fatura Adresi <b-badge variant="success" v-b-modal.invoiceModal style="cursor:pointer">+ Yeni Ekle</b-badge></label>
          <b-form-select v-model="modal.invoice_address_id" :options="invoiceAddresses" />
        </b-form-group>
        <b-row>
          <b-col class="text-right">
            <b-button @click="$refs.paymentModal.hide()">Vazgeç</b-button>
            <b-button @click="createAnOrder()" variant="primary">{{ price }} TL Ödeme Yap</b-button>
          </b-col>
        </b-row>
      </form>
    </b-modal>

    <b-modal ref="invoiceModal" id="invoiceModal" title="Fatura Adresi">

      <b-row>
        <b-col sm="6">
          <b-form-group>
            <label>Ad <span style="color:red">*</span></label>
            <b-form-input v-model="invoiceAddress.name" />
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group>
            <label>Soyad <span style="color:red">*</span></label>
            <b-form-input v-model="invoiceAddress.surname" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-form-group>
        <label>TC Kimlik <span style="color:red">*</span></label>
        <b-form-input v-model="invoiceAddress.identity_number" />
      </b-form-group>

      <b-form-group>
        <label>Telefon <span style="color:red">*</span></label>
        <b-form-input v-model="invoiceAddress.phone" />
      </b-form-group>

      <b-form-group>
        <label>E-mail <span style="color:red">*</span></label>
        <b-form-input v-model="invoiceAddress.email" />
      </b-form-group>

      <b-row>
        <b-col sm="6">
          <b-form-group>
            <label>İl <span style="color:red">*</span></label>
            <b-form-input v-model="invoiceAddress.city" />
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group>
            <label>İlçe <span style="color:red">*</span></label>
            <b-form-input v-model="invoiceAddress.county" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-form-group>
        <label>Adres <span style="color:red">*</span></label>
        <b-form-input v-model="invoiceAddress.address" />
      </b-form-group>

      <template v-slot:modal-footer>
        <b-button @click="$refs.invoiceModal.hide()">Vazgeç</b-button>
        <b-button @click="saveInvoiceAddress()" :disabled="$v.$invalid" variant="primary">Kaydet</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
const { required, email } = require('vuelidate/lib/validators')

export default {
  name: 'RenewAccount',
  mixins: [validationMixin],
  validations: {
    invoiceAddress: {
      name: {required},
      surname: {required},
      identity_number: {required},
      phone: {required},
      email: {required, email},
      city: {required},
      county: {required},
      address: {required},
    }
  },
  data() {
    return {
      loaded: false,
      waitingPayment: false,
      price: 0,
      packages: [],
      features: [
        {
          icon: 'fas fa-terminal',
          text: 'Gelir - Gider Takibi',
        },
        {
          icon: 'fas fa-terminal',
          text: 'Borç - Alacak Takibi',
        },
        {
          icon: 'fas fa-terminal',
          text: 'Müşteri Yönetimi',
        },
        {
          icon: 'fas fa-terminal',
          text: 'Ürün ve Hizmet Yönetimi',
        },
      ],
      invoiceAddresses: [],
      invoiceAddress: {},
      modal: {
        package_id: '',
        holder_name: '',
        card_number: '',
        expire_month: '',
        expire_year: '',
        cvc: '',
        invoice_address_id: '',
        type:'frozen'
      },
      threedsHTML: '',
    }
  },
  computed: {
    ...mapGetters(['user']),
    userId() {
      return this.user ? this.user.id : '';
    },
  },
  methods: {
    ...mapActions(['getPackages', 'createInvoiceAddress', 'getRenewAccount', 'createOrder']),
    saveInvoiceAddress() {
      this.createInvoiceAddress(this.invoiceAddress)
          .then(data => data.data)
          .then(response => {
            this.invoiceAddresses.push({value: response.id, text: response.full_name});
            this.modal.invoice_address_id = response.id;
            this.success('Fatura adresi başarıyla oluşturuldu!');
            this.$refs.invoiceModal.hide();
            this.invoiceAddress = {};
          }).catch(error => {
        this.error(error.response.data.message);
      })
    },
    createAnOrder() {
      this.modal.price=this.user.company.frozen_price
      this.createOrder(this.modal).then(response => {
        window.location.href=response.data.link;
        // window.location.href = 'https://ecarihesap.com/siparis/' + response.data.id
      }).catch(error => {
        this.error(error.response.data.message);
      })
    },
    showPaymentModal(id, price) {
      this.modal.package_id = id;
      this.price = price;
      this.$refs.paymentModal.show();
    },
    resetPaymentModal() {
      this.modal = {
        package_id: '',
        holder_name: '',
        card_number: '',
        expire_month: '',
        expire_year: '',
        cvc: '',
        invoice_address_id: '',
      };
    }
  },
  mounted() {
    this.loaded = false;
    this.getRenewAccount().then(response => {
      this.packages = response.data.packages;
      this.invoiceAddresses = response.data.invoice_addresses.map(item => {
        return {
          text: `${item.full_name} - ${item.city} - ${item.address}`,
          value: item.id,
        }
      });
      this.loaded = true;
    })
  }
}
</script>
